import classNames from 'classnames';
import { FC, ReactElement, memo } from 'react';
import { PreviousOrderModalProductModifiers } from '../PreviousOrderModalProductModifiers/PreviousOrderModalProductModifiers';
import { IOrderProductComboItem } from '~/types/orders';
import { getTranslate } from '~/utils/helpers';
import { productUtils } from '~/utils/productUtils';
import './style.scss';

interface IProps {
  item: IOrderProductComboItem;
  isMeal: boolean;
}

export const PreviousOrderModalProductItem: FC<IProps> = memo(({ item, isMeal }: IProps): ReactElement => {
  const productError: string | undefined = productUtils.getComboItemUnavailableMessage(item, isMeal);

  return (
    <div className="previous-order-modal-product-item">
      <p className={classNames('previous-order-modal-product-item__name', { through: productError })}>{getTranslate(item.name)}</p>

      <PreviousOrderModalProductModifiers modifiers={item.modifiers} />
      {/* TODO: combo exclusions */}
      {/* <PreviousOrderModalProductExclusions exclusions={item.exclusions} /> */}
    </div>
  );
});
